import {
  BaseEntityDTO,
  CriteriaCountTeamLevelDTO,
  IBaseEntityDTO,
  ICriteriaCountTeamLevelDTO,
  ITeamCriteriaDTO,
  TeamCriteriaDTO,
} from './';

export interface ITeamLevelDTO extends IBaseEntityDTO {
  team_level: string;
  teamCriteria: ITeamCriteriaDTO[];
  order: number;
  criteriaCounts: ICriteriaCountTeamLevelDTO[];
}

export class TeamLevelDTO extends BaseEntityDTO implements ITeamLevelDTO {
  team_level: string;
  teamCriteria: ITeamCriteriaDTO[];
  order: number;
  criteriaCounts: ICriteriaCountTeamLevelDTO[];

  constructor(data?: Partial<TeamLevelDTO>) {
    super(data);
    if (data) {
      Object.assign(this, data);
    }
    this.team_level = data?.team_level ?? '';
    this.teamCriteria = data?.teamCriteria
      ? data.teamCriteria.map((teamCrit) => new TeamCriteriaDTO(teamCrit))
      : [];
    this.order = data?.order ?? 0;

    if (data?.criteriaCounts && (data?.criteriaCounts?.length ?? 0 > 0)) {
      this.criteriaCounts = data.criteriaCounts.map(
        (cCount) => new CriteriaCountTeamLevelDTO(cCount),
      );
    } else {
      this.criteriaCounts = [new CriteriaCountTeamLevelDTO()];
    }
  }
}
